import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home'
import Login from '../views/Login.vue'

const isDevice = /(iPhone|iPod|iPad|Android|webOS|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
const SITE_DOWN = false; // Alterar para site fora do ar

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      name:  'home',
      // component: isDevice ? Login : Home,
      // name:  isDevice ? 'login' : 'home',
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Consulte CNPJ / CPF de graça. Dados de todo Brasil.'
          }
        ],
        tabSelecionado: 1
      }
    },
    {
      path: '/politica-privacidade',
      name: 'politica-privacidade',
      component: () => import('../views/politica-privacidade.vue'),
      meta: {
        title: 'CENPROT Nacional',
      }
    },
    {
      path: '/totem',
      name: 'totem',
      component: Home,
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Consulte CNPJ / CPF de graça. Dados de todo Brasil.'
          }
        ],
        totem: 1
      }
    },
    {
      path: '/carrinho',
      name: 'carrinho',
      component: () => import(/* webpackChunkName: "Consulta" */'../views/Carrinho.vue'),
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Carrinho de compras.'
          }
        ],
      }
    },
    {
      path: '/checkout/:key',
      name: 'checkout',
      component: () => import(/* webpackChunkName: "Consulta" */'../views/Checkout.vue'),
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Checkout.'
          }
        ],
      }
    },
    {
      path: '/pedidosPagamento',
      name: 'pedidos',
      component: () => import('../views/PedidosPagamento.vue'),
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Pedidos.'
          }
        ],
      }
    },
    {
      path: '/valida',
      name: 'valida',
      component: Home,
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Consulte CNPJ / CPF de graça. Dados de todo Brasil.',
            
          }
        ],
        tabSelecionado: 4
      }
    },
    // {
    //   path: '/valida',
    //   name: 'valida',
    //   component: Home,
    //   meta: {
    //     title: 'CENPROT Nacional',
    //     metaTags: [
    //       {
    //         name: 'description',
    //         content: 'Consulte CNPJ / CPF de graça. Dados de todo Brasil.'
    //       }
    //     ]
    //   }
    // },
    {
      path: '/consulta',
      name: 'consulta',
      // route level code-splitting
      // this generates a separate chunk (consulta.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Consulta" */'../views/Consulta.vue'),
      props: true,
      meta: {
        title: 'Resultados da consulta'
      }
    },
    {
      path: '/teste-webpki',
      name: 'teste-webpki',
      component: () => import(/* webpackChunkName: "TesteWebPKI" */'../views/TesteWebPKI.vue'),
      meta: {
        title: 'Teste Web PKI'
      }
    },
    {
      path: '/certidao',
      name: 'certidao',
      component: () => import('../views/Consulta.vue'),
      // component: () => import('../views/Manutencao.vue'),
      props: true,
      meta: {
        title: 'Solicitar certidão'
      }
    },
    {
      path: '/certidaoNegativa',
      name: 'certidaoNegativa',
      component: () => import('../views/Home/CertidaoNegativa.vue'),
      // component: () => import('../views/Manutencao.vue'),
      props: true,
      meta: {
        title: 'Solicitar certidão Negativa'
      }
    },
    {
      path: '/sucesso',
      name: 'sucesso',
      component: () => import('../views/Sucesso.vue'),
      props: true,
      meta: {
        title: 'Pedido de certidão enviado'
      }
    },
    {
      path: '/solicitar',
      name: 'solicitar',
      component: () => import('../views/Sucesso.vue'),
      props: true,
      meta: {
        title: 'Pedido de certidão enviado'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      props: true,
      meta: {
        title: 'Entrar',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/login-sso',
      name: 'login-sso',
      component: () => import('../views/Login-SSO.vue'),
      props: true,
      meta: {
        title: 'Entrar',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/logout-sso',
      name: 'logout-sso',
      component: () => import('../views/Logout-SSO.vue'),
      props: true,
      meta: {
        title: 'Sair',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/instrumento_protesto_cancelamento',
      name: 'instrumento_protesto_cancelamento',
      component: () => import('../views/Login.vue'),
      props:  true,
      meta: {
        title: 'Entrar',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ],
        instrumento_protesto_cancelamento : true
      }
    },
    {
      path: '/midia',
      name: 'midia',
      component: () => import('../views/Midia.vue'),
      props: true,
      meta: {
        title: 'Midia',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/produtos',
      name: 'produtos',
      component: () => import('../views/Produtos.vue'),
      props: true,
      meta: {
        title: 'Produtos',
        metaTags: [
          {
            name: 'description',
            content: 'Solicite alguns de nossos produtos.'
          }
        ]
      }
    },
    {
      path: '/servicos',
      name: 'servicos',
      component: () => import('../views/TextServicos.vue'),
      props: true,
      meta: {
        title: 'Servicos',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/servico/:servico',
      name: 'servico',
      component: () => import('../views/Servico-resumo.vue'),
      props: true,
      meta: {
        title: 'Servico',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/servico/:servico/:param_1',
      name: 'servico',
      component: () => import('../views/Servico-resumo.vue'),
      props: true,
      meta: {
        title: 'Servico',
        metaTags: [
          {
            name: 'description',
            content: 'Entre em sua conta ou realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/atendimento',
      name: 'atendimento',
      component: () => import('../views/Atendimento.vue'),
      props: true,
      meta: {
        title: 'Atendimento'
      }
    },
    // TODO
    // {
    //   path: '/blog',
    //   name: 'blog',
    //   component: () => import('../views/Blog.vue'),
    //   props: true,
    //   meta: {
    //     title: 'Blog'
    //   }
    // },
    // {
    //   path: '/post/:post',
    //   name: 'post',
    //   component: () => import('../views/Post.vue'),
    //   props: true,
    //   meta: {
    //     title: 'CENPROT Nacional'
    //   }
    // },
    {
      path: '/ajuda',
      name: 'ajuda',
      component: () => import('../views/Ajuda.vue'),
      props: true,
      meta: {
        title: 'Ajuda'
      }
    },
    // {
    //   path: '/ajuda',
    //   redirect: to => {
    //     return { path: '/'}
    //   }
    // },
    {
      path: '/saiba-mais',
      name: 'saibamais',
      component: () => import('../views/SaibaMais.vue'),
      props: true,
      meta: {
        title: 'Saiba Mais'
      }
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      component: () => import('../views/Cadastro.vue'),
      props: true,
      meta: {
        title: 'Cadastro',
        metaTags: [
          {
            name: 'description',
            content: 'Realize seu cadastro para acessar do serviços do Cenprot Nacional.'
          }
        ]
      }
    },
    {
      path: '/emolumentos',
      name: 'emolumentos',
      component: () => import('../views/Emolumentos.vue'),
      meta: {
        title: 'Aviso: Emolumentos'
      }
    },
    {
      path: '/painel',
      name: 'painel',
      component: () => import('../views/Painel.vue'),
      props: { default: true},
      meta: {
        title: 'Pedidos de Certidão',
      }
    },
    {
      path: '/cancelamento',
      name: 'cancelamento',
      component: () => import('../views/Painel.vue'),
      props: { default: true},
      meta: {
        title: 'Pedidos de Cancelamento',
        cd_produto:[3]
      }
    },
    {
      path: '/cancelamento-protesto',
      name: 'cancelamento-protesto',
      component: () => import('../views/cancelamento/CancelamentoProtesto.vue'),
      meta: {
        title: 'Cancelamento de protesto',
      }
    },
    {
      path: '/pedidoCertidao',
      name: 'pedidoCertidao',
      component: () => import('../views/Painel.vue'),
      props: { default: true},
      meta: {
        title: 'Pedidos de Certidao',
        cd_produto:[2,4]
      }
    },
    {
      path: '/cadastroUser',
      name: 'cadastroUser',
      component: () => import('../views/CadastroUser.vue'),
      props: true,
      meta: {
        title: 'Cadastro Usuário'
      }
    },
    {
      path: '/recuperar-senha',
      name: 'recuperar-senha',
      component: () => import('../views/Esqueceu.vue'),
      meta: {
        title: 'Recupere sua senha'
      }
    },
    {
      path: '/recuperar-senha/:hash',
      name: 'redefinir-senha',
      component: () => import('../views/Esqueceu.vue'),
      props: true,
      meta: {
        title: 'Redefinir senha'
      }
    },
    {
      path: '/valida-email/:id',
      name: 'valida-email',
      component: () => import('../views/ValidaLogin.vue'),
      meta: {
        title: 'Recupere sua senha',
        cd_tipo_validacao:[1]
      }
    },
    {
      path: '/valida-sms/:id',
      name: 'valida-sms',
      component: () => import('../views/ValidaLogin.vue'),
      meta: {
        title: 'Recupere sua senha',
        cd_tipo_validacao:[2]
      }
    },
    {
      path: '/pesquisaProtesto',
      name: 'pesquisaprotesto',
      component: () => import('../views/PesquisaProtesto.vue'),
      props: true,
      meta: {
        title: 'Pesquisa de Protestos'
      }
    },
    // {
    //   path: '/cancelamentoProtesto',
    //   name: 'cancelamentoprotesto',
    //   component: () => import('../views/CancelamentoProtesto.vue'),
    //   props: true,
    //   meta: {
    //     title: 'Cancelamento de protesto'
    //   }
    // },
    {
      path: '/cartorios',
      name: 'cartorios',
      component: () => import('../views/Cartorios.vue'),
      props: true,
      meta: {
        title: 'Cartórios Participantes'
      }
    },
    // {
    //   path: '/convenio',
    //   name: 'convenio',
    //   component: () => import('../views/Convenio.vue'),
    //   props: true,
    //   meta: {
    //     title: 'Cartórios Participantes'
    //   }
    // },
    // {
    //   path: '/VerifTituloAnuencia',
    //   name: 'VerifTituloAnuencia',
    //   component: () => import('../views/VerifTituloAnuencia.vue'),
    //   props: true,
    //   meta: {
    //     title: 'Pesquisa de Título com anuência'
    //   }
    // },
    {
      path: '/EditalEletronico',
      name: 'EditalEletronico',
      component: () => import('../views/EditalEletronico.vue'),
      props: true,
      meta: {
        title: 'Pesquisa de Edital Eletronico'
      }
    },
    {
      path: '/VerifInstProt',
      name: 'VerifInstProt',
      component: () => import('../views/VerifInstProt.vue'),
      props: true,
      meta: {
        title: 'Verificação de Instrumento de Protesto'
      }
    },

    //Cadastrar Procuração - processo inicial da Anuencia
    {
      path: '/procuracao/cadastro',
      name: 'procuracaoCadastro',
      component: () => import('../views/procuracao/cadastro.vue'),
      props: true,
      meta: {
        title: 'Cadastro de procuração'
      }
    },
    {
      path: '/procuracao/pesquisar',
      name: 'procuracaoPesquisar',
      component: () => import('../views/procuracao/pesquisar.vue'),
      props: true,
      meta: {
        title: 'Pesquisar procuração'
      }
    },
    {
      path: '/textobotao',
      name: 'textobotao',
      component: () => import('../views/TextoBotao.vue'),
      props: true,
      meta: {
        title: 'Texto botoes'
      }
    },
    {
      path: '/anuenciaDigital',
      name: 'anuenciaDigital',
      // component: () => import('../views/Manutencao.vue'),
      component: () => import('../views/anuencia/pesquisar.vue'),
      props: true,
      meta: {
        title: 'Pesquisar anuência'
      }
    },
    {
      path: '/aprovadas',
      name: 'aprovadas',
      component: () => import('../views/anuencia/aprovadas.vue'),
      props: true,
      meta: {
        title: 'Pesquisar anuência'
      }
    },
    {
      path: '/renegociacao_divida/solicitacao',
      name: 'renegociacao_divida/solicitacao',
      component: () => import('../views/renegociacao_dividas_protestadas/solicitacao.vue'),
      props: true,
      meta: {
        title: 'Solicitação - Renegociaçao de dividas a protesto'
      }
    },
    {
      path: '/renegociacao_divida/pedidos',
      name: 'renegociacao_divida/pedidos',
      component: () => import('../views/renegociacao_dividas_protestadas/pedidos.vue'),
      props: true,
      meta: {
        title: 'Pedidos - Renegociaçao de dividas a protesto'
      }
    },
    {
      path: '/ConsultaDeTitulos',
      name: 'ConsultaDeTitulos', 
      component: () => import('../views/ConsultaDeTitulos.vue'),
      props: true,
      meta: {
        title: 'Consulta de Títulos',
      }
    },
    {
      path: '/PedidoProtesto',
      name: 'PedidoProtesto', 
      component: () => import('../views/protesto/PedidoProtesto.vue'),
      props: true,
      meta: {
        title: 'Novo Pedido de Protesto',
      }
    },
  {
      path: '/v2/PedidoProtesto',
      name: 'PedidoProtesto-V2',
      component: () => import('../views/protesto/NewPedidoProtesto.vue'),
      props: true,
      meta: {
          title: 'Novo Pedido de Protesto',
      }
  },
    {
      path: '/consulta-resolve',
      name: 'consulta-resolve',
      component: () => import('../views/ConsultaResolve.vue'),
      props: { default: true},
      meta: {
        title: 'Pedidos Resolve',
        cd_produto:[3],
        ic_resolve: true
      }
    },
    {
      path: '/avise-me/adesao',
      name: 'avise-me/adesao', 
      component: () => import('../views/avise-me/adesao.vue'),
      props: true,
      meta: {
        title: 'Avise-me, Adesão!',
      }
    },
    {
      path: '/avise-me',
      name: 'avise-me', 
      component: () => import('../views/avise-me/index.vue'),
      props: true,
      meta: {
        title: 'Avise-me! - Meus avisos',
      }
    },
    {
      path: '/VisualizarPedidoProtesto',
      name: 'VisualizarPedidoProtesto', 
      component: () => import('../views/protesto/pesquisar.vue'),
      props: true,
      meta: {
        title: 'Consulta - Pedidos de Protesto realizados',
      }
    },
    {
      path: '/pedido_retirada',
      name: 'PedidoRetirada',
      component: () => import('../views/protesto/PedidoRetirada.vue'),
      props: true,
      meta: {
        title: 'Envio de Títulos - Retirada',
      }
    },
    {
      path: '/custas',
      name: 'custas',
      component: () => import('../views/Boleto_UUID.vue'),
      props: true,
      meta: {
        title: 'Pesquisa de boleto'
      }
    },
    {
      path: '/distribuidor',
      name: 'distribuidor',
      component: () => import('../views/distribuidor.vue'),
      props: true,
      meta: {
        title: 'Pesquisa de Recibo'
      }
    },
    {
      path: '/jornal-eletronico',
      name: 'JornalEletronico',
      component: () => import('../views/Jornal-eletronico.vue'),
      props: true,
      meta: {
        title: 'Jornal Eletrônico'
      }
    },
    {
      path: '/termo-aceite-site',
      name: 'termo-aceite-site',
      component: () => import('../views/TermoAceite.vue'),
      props: true,
      meta: {
        title: 'CENPROT Nacional',
      }
    },
    {
      path: '/:code',
      name: 'homeGov',
      component: Home,
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Consulte CNPJ / CPF de graça. Dados de todo Brasil.'
          }
        ],
        tabSelecionado: 1
      }
    },
    {
      path: '/download-generico/:nm_chave/:cd_download_generico',
      name: 'download-generico',
      component: () => import('../views/DownloadGenerico.vue'), 
      meta: {
        title: 'CENPROT Nacional',
        metaTags: [
          {
            name: 'description',
            content: 'Download Generico'
          }
        ],
        tabSelecionado: 1
      }
    },
    {
      path: '/manutencao',
      name: 'manutencao',
      component: () => import('../views/Manutencao.vue'),
      meta: {
        title: 'CENPROT Nacional',
      }
    },
  ]
})

const openRoutes=[
  'cadastro',
  // 'cadastroUser',
  'cartorios',
  'certidao',
  'consulta',
  // 'convenio',
  'emolumentos',
  'home',
  'homeGov',
  'login',
  'login-sso',
  'midia',
  'recuperar-senha',
  'redefinir-senha',
  'valida-email',
  'valida-sms',
  'VerifInstProt',
  // 'VerifTituloAnuencia',
  'EditalEletronico',
  'custas',
  'distribuidor',
  'servicos',
  'produtos',
  'servico',
  'pesquisaprotesto',
  'cancelamentoprotesto',
  'valida',
  'instrumento_protesto_cancelamento',
  'atendimento',
  'portaldotitular',
  'cancelamento-protesto',
  // 'blog',
  // 'post',
  'ajuda',
  'saibamais',
  'JornalEletronico',
  'totem',
  'politica-privacidade',
  'download-generico',
  'manutencao',
  'teste-webpki'
];
const govOuroRoutes=[
  'anuenciaDigital',
  'aprovadas',
  'renegociacao_divida/solicitacao',
  'renegociacao_divida/pedidos'
];
const govPrataRoutes=[
  'PedidoProtesto',
  'VisualizarPedidoProtesto'
];

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  if (SITE_DOWN && to.name !== 'manutencao') {
    next({ name: 'manutencao' });
    return;
  }
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // useless ->
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  //if(!nearestWithMeta) return next();
  //CONTROLE LOGIN
  if(nearestWithMeta){
    //CONTROLE LOGIN

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));


  }
  let logged = (localStorage.getItem('jwtToken') != undefined
              && localStorage.getItem('jwtToken') != null
              && localStorage.getItem('jwtToken').length > 100
              && sessionStorage.getItem('jwtToken') != null
              && sessionStorage.getItem('jwtToken') != undefined
  );
  let termoAtualizado = localStorage.getItem('tokenTermo');
  termoAtualizado = !(termoAtualizado == 'false')
  next();
  if(openRoutes.includes(to.name)){
    if(logged){
      // if (!termoAtualizado && to.name !== 'termo-aceite-site') next('/termo-aceite-site');
      // else if (termoAtualizado && to.name === 'termo-aceite-site') next('/');
    }
    next();
  } else
    if (localStorage.getItem('jwtToken') != undefined
          && localStorage.getItem('jwtToken') != null
          && localStorage.getItem('jwtToken').length > 100
          && sessionStorage.getItem('jwtToken') != null
          && sessionStorage.getItem('jwtToken') != undefined
          ) {
    let redirect = false;
    if(localStorage.getItem('pxppwiru9') != undefined
          && localStorage.getItem('pxppwiru9') != null
          && sessionStorage.getItem('pxppwiru9') != null
          && sessionStorage.getItem('pxppwiru9') != undefined){
      if(govOuroRoutes.includes(to.name)){
        redirect = (localStorage.getItem('lhwvzhds3') === '3');
      }
      else if (govPrataRoutes.includes(to.name)){
        redirect = (localStorage.getItem('lhwvzhds3') === '3' || localStorage.getItem('lhwvzhds3') === '2');
      }
      else redirect = true;
    }
    else{
      redirect = true;
    }
    if(redirect){
      setTimeout(()=>{
        sessionStorage.removeItem('jwtToken')
        location.href = '/'
      },3600000)
      // if (!termoAtualizado && to.name !== 'termo-aceite-site') next('/termo-aceite-site');
      // else if (termoAtualizado && to.name === 'termo-aceite-site') next('/');
      //3600000 = 1 hr
      next();
    }
    else{
      next('/');
    }
  } else {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('lhwvzhds3');
    localStorage.removeItem('t178w3gm3');
    localStorage.removeItem('pxppwiru9');
    localStorage.removeItem('tokenTermo');
    localStorage.removeItem('usrCpf');
    localStorage.removeItem('usrEmail');
    localStorage.removeItem('libAnuencia');
    localStorage.removeItem('libProcuracao');
    localStorage.removeItem('nm_nr_documento_cert');
    localStorage.removeItem('sg_tipo_documento');
    localStorage.removeItem('SSL_CLIENT_S_DN');
    localStorage.removeItem('SSL_CLIENT_S_DN_CN');
    localStorage.removeItem('SSL_CLIENT_V_END');
    localStorage.removeItem('SSL_CLIENT_V_START');
    localStorage.removeItem('nm_thumbprint');
    localStorage.removeItem('nm_thumbprint_sha256');
    localStorage.removeItem('nm_tipo_certificado');
    next('/login');
  }
})

export default router
